/** C0 controls and DEL — never part of a path the app builds. */
const CONTROL_CHARACTERS = /[\u0000-\u001F\u007F]/

/**
 * Sep 24 — where /pay may send the payer when they are done (`?returnTo=`): a path on
 * THIS origin, normalized, or null.
 *
 * `returnTo` arrives in a URL anyone can craft, so only an app-relative path survives:
 * it must start with a single `/` (a protocol-relative `//host` and `/\host` are other
 * sites in a browser), carry no backslash or control character, and still resolve to
 * `origin` once parsed. Everything else — an absolute URL, `javascript:`, an empty
 * value — is null, and the caller falls back to Home.
 *
 * @param raw - the decoded `returnTo` value (URLSearchParams.get decodes it)
 * @param origin - the page's own origin, `window.location.origin`
 */
export const safeReturnPath = (
  raw: string | null | undefined,
  origin: string
): string | null => {
  if (
    typeof raw !== 'string' ||
    !raw.startsWith('/') ||
    raw.startsWith('//') ||
    raw.includes('\\') ||
    CONTROL_CHARACTERS.test(raw)
  ) {
    return null
  }

  let parsed: URL
  let base: URL
  try {
    base = new URL(origin)
    parsed = new URL(raw, base)
  } catch {
    return null
  }

  if (parsed.origin !== base.origin) {
    return null
  }

  return `${parsed.pathname}${parsed.search}${parsed.hash}`
}
